import React from 'react';
import { create } from 'jss';
import rtl from 'jss-rtl';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import StylesProvider from '@material-ui/styles/StylesProvider';
import PropTypes from 'prop-types';

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

// Custom Material-UI class name generator.
const generateClassName = createGenerateClassName();

const RTL = (props) => {
  return (
    <StylesProvider jss={jss} generateClassName={generateClassName}>
      {props.children}
    </StylesProvider>
  );
};

RTL.propTypes = {
  children: PropTypes.node
};

export default RTL;
